import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import api from './api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    // password: '',
    token: null,
    isLoading: false
  },
  actions: {
    async login (context, { username, password }) {
      try {
        const { data } = await axios.post('https://vrcam-prod-api.istaging.com/api/v1/users/login?istagingHeadquarterTitle​=liveabc', {
          'username': username,
          'password': password
        })
        let status = {
          username: username,
          // password: password,
          token: data.sessionToken

        }
        window.localStorage.setItem('login', JSON.stringify(status))
        context.commit('LOGIN', status)
      } catch (error) {
        console.log(error)
      }
    }
  },
  mutations: {
    isLoading (state, value) {
      state.isLoading = value
    },
    LOGIN (state, status) {
      state.username = status.username
      state.password = status.password
      state.token = status.token
    }
  },
  getters: {
    isLoading: state => state.isLoading,
    username: state => state.username,
    password: state => state.password,
    token: state => state.token
  }
})
